import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export interface GalleryCategory {
  id: string;
  name: string;
}

export const defaultCategories: GalleryCategory[] = [
  { id: 'apartments', name: 'Апартаменти' },
  { id: 'common-areas', name: 'Общи части' },
  { id: 'pool', name: 'Басейн' },
  { id: 'sea-view', name: 'Изглед към морето' },
  { id: 'surroundings', name: 'Околност' },
];

export const useGalleryCategories = () => {
  const [categories, setCategories] = useState<GalleryCategory[]>(defaultCategories);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const snap = await getDoc(doc(db, 'content', 'galleryCategories'));
      if (snap.exists() && Array.isArray(snap.data().categories)) {
        setCategories(snap.data().categories as GalleryCategory[]);
      } else {
        setCategories(defaultCategories);
      }
      setError(null);
    } catch (err) {
      console.error('Error fetching gallery categories:', err);
      setError('Грешка при зареждане на категориите');
      setCategories(defaultCategories);
    } finally {
      setLoading(false);
    }
  };

  const saveCategories = async (next: GalleryCategory[]) => {
    try {
      await setDoc(doc(db, 'content', 'galleryCategories'), {
        categories: next,
        updatedAt: serverTimestamp(),
      });
      setCategories(next);
      return true;
    } catch (err) {
      console.error('Error saving gallery categories:', err);
      setError('Грешка при запазване на категориите');
      return false;
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return { categories, loading, error, saveCategories, refreshCategories: fetchCategories };
};
